import { render, staticRenderFns } from "./DilationButton.vue?vue&type=template&id=4d5e53d0&scoped=true&"
import script from "./DilationButton.vue?vue&type=script&lang=js&"
export * from "./DilationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5e53d0",
  null
  
)

export default component.exports